import { Controller } from "@hotwired/stimulus"
import lightGallery from 'lightgallery';

// Import plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

// Import styles
import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-thumbnail.css'

export default class extends Controller {
    connect() {
        this.galleries = [];
        const items = this.element.querySelectorAll('a.gallery-item');

        items.forEach(item => {
            const gallery = lightGallery(item, {
                plugins: [lgThumbnail, lgZoom],
                speed: 500,
                selector: 'this', // Important: Treat the element itself as the gallery item
                download: false,
                mode: 'lg-fade',
                backdropDuration: 300,
                controls: false, // Hide next/prev controls explicitly
                counter: false,   // Hide counter (1/1)
                allowMediaOverlap: false,
                toggleThumb: false, // Thumbnails don't make sense for single image
            });
            this.galleries.push(gallery);
        });
    }

    disconnect() {
        this.galleries.forEach(gallery => gallery.destroy());
        this.galleries = [];
    }
}
